import { carrotClient } from "#/utils/CarrotClient"
import { useMutation, UseMutationResult } from "@tanstack/react-query"

export function useTelemedicineMenopauseInterest(): UseMutationResult<void, unknown, void> {
  return useMutation(() => carrotClient.createTelemedicineMenopauseInterest(), {
    retry: false
  })
}

export function useTelemedicinePelvicFloorTherapyInterest(): UseMutationResult<void, unknown, void> {
  return useMutation(() => carrotClient.createTelemedicinePelvicFloorTherapyInterest(), {
    retry: false
  })
}
